import type { Method } from 'lib/axios';
import { APICallV4 } from 'reactApp/api/APICall';

export class GetAlbumAPICall extends APICallV4 {
    _method = 'album/get';
    _type: Method = 'get';
    _retriesCount = 0;
}
